var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarRating = function SvgStarRating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 14 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAA61A",
    d: "m8.153 1.84 1.174 2.347c.16.326.586.64.946.7l2.127.353c1.36.227 1.68 1.213.7 2.187L11.447 9.08c-.28.28-.434.82-.347 1.207l.473 2.046c.374 1.62-.486 2.247-1.92 1.4l-1.993-1.18c-.36-.213-.953-.213-1.32 0l-1.993 1.18c-1.427.847-2.294.214-1.92-1.4l.473-2.046c.087-.387-.067-.927-.347-1.207L.9 7.427c-.973-.974-.66-1.96.7-2.187l2.127-.353c.353-.06.78-.374.94-.7L5.84 1.84c.64-1.273 1.68-1.273 2.313 0Z"
  })));
};
export default SvgStarRating;